// eslint-disable-next-line no-restricted-imports
import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@material-ui/core';

/**
 * Dividers separate things.
 *
 * ```js
 * import { Divider } from 'bento';
 * ```
 *
 */

export type DividerPosition = 'top' | 'bottom' | 'middle';
export type DividerWeight = 'thin' | 'thick';

export type DividerProps = MuiDividerProps & {
  tall: boolean;
  weight: DividerWeight;
  position?: DividerPosition;
};

/**
 * @deprecated Deprecated — use pantry Divider instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-divider--docs
 * Migration: Replace Divider with the pantry Divider component.
 */
export const Divider = (props: MuiDividerProps) => {
  return <MuiDivider {...props} />;
};
